
export const setFirestoreReady = (state, payload) => {
  state.firestoreReady = payload
}

export const setSettingsOpen = (state, payload) => {
  state.settingsOpen = payload
}

export const setSettingsSearchTerm = (state, payload) => {
  state.settingsSearchTerm = payload
}

export const setSearchOpen = (state, payload) => {
  state.searchOpen = payload
}

export const setSearchTerm = (state, payload) => {
  state.searchTerm = payload
}

export const setReorderModalOpen = (state, payload) => {
  state.reorderModalOpen = payload
}

export const setReorderModalItemId = (state, payload) => {
  state.reorderModalItemId = payload
}

export const setDistractionFreeMode = (state, payload) => {
  state.distractionFreeMode = payload
}

export const setSkipMdRender = (state, value) => {
  state.skipMdRender = value
}

export const setOfflinePersistenceEnabled = (state, value) => {
  state.offlinePersistenceEnabled = value
}

export const setCurrentSessionIndex = (state, value) => {
  state.currentSessionIndex = value
}

export const addToComponentLog = (state, value) => {
  state.componentLog += value + '\n'
}

export const clearComponentLog = (state) => {
  state.componentLog = `Log: ${new Date()}\n`
}

export const updateOnlineStatus = (state, isFromCache) => {
  /*
   * hasPendingWrites is
   * docChange.doc.metadata.isFromCache
   */
  state.onlineStatus = !isFromCache
  console.log(state.onlineStatus ? 'Online' : 'Offline')
}
